import React from "react";
import { useRouter } from "next/router";
import SingleJobListing from "@/components/jobs/JobListing/SingleJobListing";
import { getJobsFromAPI, getJob, getRelatedJobsFromAPI } from "@/lib/backend";

import PageSection from "@/common/Layout/PageSection";
import JobsCards from "@/components/jobs/JobList/JobsListQuery";
import Translator from "@/components/hoc/Translator";

const pageStyles = `
  background-color: transparent;
  min-height: 0 !important;
  width: 100%;
  max-width: 100%;
  padding: 0;
  align-items: stretch;
`;

const SingleJobView = (props) => {
  const router = useRouter();
  const { jid } = router.query;
  const jobId = extractJobId(jid);

  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  if (!props.jobData) {
    return <p>No job found.</p>;
  }

  return (
    <div className="singleJobRelatedContainer">
      <aside className="RelatedJobsContainer">
        <div className="RelatedJobsHeading">
          <Translator>Related Jobs</Translator>
        </div>
        <JobsCards
          location={props.jobData.location.name}
          jobId={jobId}
          jobs={props.relatedJobs}
          compact
        />
      </aside>
      <PageSection styles={pageStyles} nopadding row notFullWidth>
        <div className="JobContainer">
          <SingleJobListing
            jobData={props.jobData}
            jobId={jobId}
            countView
          />
          <style jsx>
            {`
              .JobContainer {
                width: 100%;
                max-width: 880px;
                padding-top: 0;
                margin: 0;
              }
            `}
          </style>
        </div>
      </PageSection>
    </div>
  );
}; //eof

export async function getStaticPaths() {
  if (process.env.NODE_ENV === "development") {
    return { paths: [], fallback: "blocking" };
  }

  try {
    const jobs = (await getJobsFromAPI()) || [];
    const jobsPaths = jobs.map((job) => {
      const jobPath = `${job.title.replace(
        /[\W_]+/g,
        "-"
      )}-${job.location.name.replace(/[\W_]+/g, "-")}-${job.id}`;
      return { params: { jid: jobPath } };
    });
    return {
      paths: jobsPaths,
      fallback: "blocking",
    };
  } catch (error) {
    console.log(error);
    return { paths: [], fallback: "blocking" };
  }
}

export async function getStaticProps({ params }) {
  const { jid } = params;
  const jobId = extractJobId(jid);
  const jobData = await getJob(jobId);
  let relatedJobs = null;
  if (jobData?.location?.name) {
    try {
      relatedJobs = (await getRelatedJobsFromAPI(jobData.location.name)) || [];
    } catch (error) {
      console.log(error);
    }
  }

  return {
    props: { jobData, jobId, relatedJobs },
    revalidate: 1,
  };
}

function extractJobId(slug) {
  if (slug) {
    const slugParts = slug.split("-");
    const jobId = slugParts[slugParts.length - 1];
    return jobId;
  }
  return undefined;
}

export default SingleJobView;
